import { Box } from "@mui/material";
import { MiPrintTableContent } from "./MiPrintTableContent";
import { MiPrintTemplate } from "./MiPrintTemplate";

export const MiPrintTable = ({
  data = [],
  columns,
  columnHeaderHeight = 24,
  rowHeight = 58,
  account,
  settings,
}) => {
  const rows = data.map((item, index) => ({
    id: item?.id || index,
    ...item,
  }));

  const ROWS_PER_PAGE_FIRST = 12;
  const ROWS_PER_PAGE_SUBSEQUENT = 14;

  const pages = [];
  let currentRow = 0;

  while (currentRow < rows.length) {
    const isFirstPage = pages.length === 0;
    const limit = isFirstPage ? ROWS_PER_PAGE_FIRST : ROWS_PER_PAGE_SUBSEQUENT;

    const pageRows = rows.slice(currentRow, currentRow + limit);

    pages.push(
      <MiPrintTemplate
        key={`page-${pages.length}`}
        hideFooter
        hideHeader={!isFirstPage}
        account={account}
        orientation={settings?.orientation}
        headerFields={[{ label: "Total Records", value: rows.length }]}
      >
        <MiPrintTableContent
          data={pageRows}
          columns={columns}
          columnHeaderHeight={columnHeaderHeight}
          rowHeight={rowHeight}
          gridProps={settings?.gridProps}
        />
      </MiPrintTemplate>
    );

    currentRow += limit;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>{pages}</Box>
  );
};
